import axios from "@/plugins/axios"
const token = localStorage.getItem("token");

export default {
    // async getAllAutoJobCards(){
    //     let jobCards = [];
    //     const response = await axios.getData("/auth/get-All-service-cards", token);
    //     if (response?.status === "success") {
    //         jobCards = response.services;
    //     }
    //     return jobCards;
    // },

    async getProjectByInvoiceNumber(invoiceNumber){
        let project = null;
        const response = await axios.postDataWithToken("/auth/get-project-by-invoice-number",{invoiceNumber},token);
        if (response?.status === "success") {
            project = response.project;
        }
        return project;
        
    }
}